import { render, staticRenderFns } from "./BillingCancel.vue?vue&type=template&id=6e2ad084&scoped=true"
import script from "./BillingCancel.vue?vue&type=script&lang=js"
export * from "./BillingCancel.vue?vue&type=script&lang=js"
import style0 from "./BillingCancel.vue?vue&type=style&index=0&id=6e2ad084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ad084",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
